<template>
  <v-container fluid>
    <v-row>
      <!-- filter -->
      <v-col cols="12" md="3" class="mt-3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <v-select
              v-model="userId"
              :items="users"
              item-text="name"
              item-value="id"
              label="Клиент"
              @input="onChangeFilter"
              dense
              outlined
              :loading="loading"
            ></v-select>
            <v-select
              v-model="billingType"
              :items="billingTypes"
              item-text="name"
              item-value="id"
              label="Тип данных"
              dense
              outlined
              :disabled="!userId"
              @change="refresh"
            ></v-select>

            <!-- <v-btn class="ma-2" color="primary" @click="refreshDetail()">Обновить данные детализации</v-btn>                         -->
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header>Отчет по всем пользователям</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="ma-0">
                    <v-col class="pa-0">
                      <v-btn class="ma-2" color="primary" @click="report()">Выгрузить в EXCEL</v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </wapi-panel>
      </v-col>
      <!-- billing -->
      <v-col
        cols="12"
        md="9"
        v-if="billingType === wapiDataType.Forecast || billingType === wapiDataType.Reanalys"
      >
        <v-row>
          <v-col cols="12" md="6">
            <wapi-panel :title="'Всего территорий'">
              <template v-slot:content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <apexchart
                      type="radialBar"
                      height="150"
                      :options="chartOptions"
                      :series="presetsSeries"
                    ></apexchart>
                  </v-col>
                  <v-col cols="12" md="8">
                    <h2 class="text-center">
                      <strong>{{ billingArea.active_area }} / {{ billingArea.max_area }}</strong>
                      <br />
                      <small>активных территорий / доступно по договору (км²)</small>
                    </h2>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
          <v-col cols="12" md="6">
            <wapi-panel :title="'Площадь запросов территорий'">
              <template v-slot:content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <apexchart
                      type="radialBar"
                      height="150"
                      :options="chartOptions"
                      :series="requestsAreaPresetsSeries"
                    ></apexchart>
                  </v-col>
                  <v-col cols="12" md="8">
                    <h2 class="text-center">
                      <strong>{{ billingRequests.current_request_area }} / {{ billingRequests.max_request_area }}</strong>
                      <br />
                      <small>сделано запросов / доступно по договору (км²)</small>
                    </h2>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
          <v-col cols="12" md="6">
            <wapi-panel :title="'Количество запросов территорий'">
              <template v-slot:content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <apexchart
                      type="radialBar"
                      height="150"
                      :options="chartOptions"
                      :series="requestsCountPresetsSeries"
                    ></apexchart>
                  </v-col>
                  <v-col cols="12" md="8">
                    <h2 class="text-center">
                      <strong>{{ billingRequests.current_preset_request_count }} / {{ billingRequests.max_preset_request_count }}</strong>
                      <br />
                      <small>сделано запросов / доступно по договору (шт)</small>
                    </h2>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
          <v-col cols="12" md="6">
            <wapi-panel :title="'Запросы в точке'">
              <template v-slot:content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <apexchart
                      type="radialBar"
                      height="150"
                      :options="chartOptions"
                      :series="requestsPointSeries"
                    ></apexchart>
                  </v-col>
                  <v-col cols="12" md="8">
                    <h2 class="text-center">
                      <strong>{{ billingRequests.current_point_request_count }} / {{ billingRequests.max_point_request_count }}</strong>
                      <br />
                      <small>сделано запросов / доступно по договору (шт)</small>
                    </h2>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
        </v-row>
      </v-col>
      <!-- billing -->
      <v-col cols="4" v-if="billingType === wapiDataType.Radar">
        <wapi-panel :title="'Запросы'">
          <template v-slot:content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <apexchart
                  type="radialBar"
                  height="150"
                  :options="chartOptions"
                  :series="requestsSeries"
                ></apexchart>
              </v-col>
              <v-col cols="12" md="8">
                <h2 class="text-center">
                  <strong>{{ radarInfo.current_request_count }} / {{ radarInfo.max_request_count_day }}</strong>
                  <br />
                  <small>Сделано на текущий момент / лимит в сутки</small>
                  <br />
                  <span
                    class="subtitle-2"
                  >[{{ radarInfo.current_validtime_request_count }}] Заблаговременностей запрошено</span>
                  <br />
                  <span
                    class="subtitle-2"
                  >[{{ radarInfo.max_validtime_request_count }}] лимит заблаговременностей в месяц</span>
                </h2>
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>

    <!-- detail -->
    <v-row>
      <v-col>
        <wapi-panel :title="'Детализация биллинга'">
          <template v-slot:content>
            <v-row>
              <!-- dates -->
              <!-- datestart -->
              <v-col cols="12" md="3">
                <v-menu
                  ref="menuDateStart"
                  v-model="menuDateStart"
                  :close-on-content-click="false"
                  :return-value.sync="dateStart"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateStart"
                      label="Начальная дата"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateStart" no-title scrollable @change="refresh">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuDateStart = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuDateStart.save(dateStart)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <!-- dateend -->
                <v-menu
                  ref="menuDateEnd"
                  v-model="menuDateEnd"
                  :close-on-content-click="false"
                  :return-value.sync="dateEnd"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateEnd"
                      label="Конечная дата"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateEnd" no-title scrollable @change="refresh">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuDateEnd = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuDateEnd.save(dateEnd)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-0">
                <billing-detail
                  :options="options"
                  :length="totalBilling"
                  :model="filteredBilling"
                  :dataType="billingType"
                  v-on:optionschange="optionsChange"
                />
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BillingDetail from "../components/BillingDetail.vue";
import WapiPanel from "../components/WapiPanel";
import moment from "moment";
import { WapiDataType, GetWapiCoordinateOrderType, LAT_LON } from "../constants";

export default {
  name: "BillingView",
  title: "Биллинг",
  components: {
    BillingDetail,
    WapiPanel
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
    this.billingTypes = this.$store.getters.BILLING_TYPES;
    this.loading = false;
  },
  data: function() {
    return {
      totalBilling: 0,
      options: {},
      presetsSeries: [0],
      requestsPresetsSeries: [0],
      requestsAreaPresetsSeries: [0],
      requestsCountPresetsSeries: [0],
      requestsPointSeries: [0],
      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%"
            }
          }
        },
        labels: [""],
        loading: false
      },
      users: [],
      userId: "",
      presetId: "",
      dateStart: moment()
        .add(-1, "days")
        .toISOString()
        .substr(0, 10),
      dateEnd: moment()
        .add(1, "days")
        .toISOString()
        .substr(0, 10),
      menuDateStart: false,
      menuDateEnd: false,
      billing: [],
      billingArea: {},
      billingRequests: {},
      loading: false,
      billingType: WapiDataType.Forecast,
      billingTypes: [],
      /**
       * radar
       */
      requestsSeries: [0],
      requestsBaseTimeSeries: [0],
      requestsValidTimeSeries: [0],
      radarInfo: {},
      wapiDataType: WapiDataType,
      coordinateOrder: LAT_LON
    };
  },
  computed: {
    filteredBilling() {
      return this.billing.filter(x => x.data_type == this.billingType);
    }
  },
  methods: {
    async onChangeFilter() {
      await this.refresh();
    },
    async refresh() {
      if (!this.userId) return;

      await this.$store.dispatch("SET_LOADING", true);
      const request = {
        userId: this.userId,
        from: this.dateStart,
        to: this.dateEnd,
        data_type: this.billingType
      };

      this.totalBilling = (
        await this.$store.dispatch("FETCH_BILLING_COUNT", request)
      ).count;
      this.options.page = 1;
      this.refreshDetail();

      await this.$store.dispatch("FETCH_BILLING_AREA", this.userId);
      this.billingArea = this.$store.getters.BILLING_AREA;

      await this.$store.dispatch("FETCH_BILLING_REQUESTS", this.userId);
      this.billingRequests = this.$store.getters.BILLING_REQUESTS;

      const presetsPersent =
        Math.round(
          (this.billingArea.active_area / this.billingArea.max_area) * 100
        ) || 0;
      const requestsAreaPresetsPersent =
        Math.round(
          (this.billingRequests.current_request_area /
            this.billingRequests.max_request_area) *
            100
        ) || 0;
      const requestsCountPresetsPersent =
        Math.round(
          (this.billingRequests.current_preset_request_count /
            this.billingRequests.max_preset_request_count) *
            100
        ) || 0;
      const requestsPointPersent =
        Math.round(
          (this.billingRequests.current_point_request_count /
            this.billingRequests.max_point_request_count) *
            100
        ) || 0;

      this.presetsSeries = [presetsPersent];
      this.requestsAreaPresetsSeries = [requestsAreaPresetsPersent];
      this.requestsCountPresetsSeries = [requestsCountPresetsPersent];
      this.requestsPointSeries = [requestsPointPersent];

      await this.$store.dispatch("FETCH_USER_RADAR_INFO", this.userId);
      this.radarInfo = this.$store.getters.RADAR_INFO;
      const requestsPersent =
        Math.round(
          (this.radarInfo.current_request_count /
            this.radarInfo.max_request_count_day) *
            100
        ) || 0;
      this.requestsSeries = [requestsPersent];
      await this.$store.dispatch("FETCH_CONTRACTS", this.userId);
      const contractResponse = await this.$store.getters.CONTRACT_BY_USERID(this.userId);
      this.coordinateOrder = GetWapiCoordinateOrderType(contractResponse.preset_settings.coordinate_order);
      
      await this.$store.dispatch("SET_LOADING", false);
    },
    async refreshDetail() {
      if (!this.userId) return;
      const { page, itemsPerPage } = this.options;
      const request = {
        userId: this.userId,
        from: this.dateStart,
        to: this.dateEnd,
        take: 10,
        skip: (page - 1) * itemsPerPage || 0,
        data_type: this.billingType
      };

      await this.$store.dispatch("FETCH_BILLING", request);
      this.billing = this.$store.getters.BILLING;
    },
    async report() {
      let from = this.dateStart;
      let to = this.dateEnd;

      const request = {
        userId: this.userId,
        from: from,
        to: to
      };

      await this.$store.dispatch("BILLING_ALL_USER_REPORT", request);
    },
    async optionsChange(val) {
      await this.$store.dispatch("SET_LOADING", true);
      this.options = val;
      this.refreshDetail();
      await this.$store.dispatch("SET_LOADING", false);
    }
  }
};
</script>